import $ from 'jquery';

export default function bind() {
  $('div.complexCheckbox div.ui.checkbox').each((index, element) => {
    const $input = $(element);

    $input.on('change', evt => {
      const checked = $(evt.target)
        .parent()
        .hasClass('checked');
      // if (checked) {
      //   $input.removeAttr('disabled');
      // } else {
      //   $input.attr('disabled', 'disabled');
      //   $input.val('');
      // // }
      const index = $input.find('input').attr('data-index');
      const textFields = $input
        .parent()
        .parent()
        .find(`input[type='text'][data-index='${index}']`);
      if (checked) {
        textFields.prop('disabled', false);
      } else {
        textFields.prop('disabled', true);
        textFields.prop('value', '');
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/plugins/complex-checkboxes.js